module.exports = __webpack_public_path__ + "img/adtbg3.3e484434.png";